<app-standard-page>
  @if (status === StartStatus.Loading) {
    <app-loading></app-loading>
  }

  @if (status === StartStatus.Questions) {
    <app-standard-page-content [limitWidth]="true">
      <div class="card-body fs-4">
        <div class="row mt-4">
          <div class="col-12 col-lg-6">
            <h1 class="text-primary">Let's kick some assets!</h1>

            <p>
              Here's a couple of questions so we can get you set up and take the
              boring work off your hands...
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <app-onboarding-questions
              (complete)="questionsComplete()"
            ></app-onboarding-questions>
          </div>
          <div class="col-12 col-lg-6">
            <app-reviews [status]="status"></app-reviews>
          </div>
        </div>
      </div>
    </app-standard-page-content>
  }
</app-standard-page>
